var map = {
	"./address_image.svg": 78,
	"./animated_logo.svg": 79,
	"./animated_lok.PNG": 80,
	"./blogs_image.svg": 81,
	"./cloud_infrastructure.svg": 82,
	"./codeInLogo.png": 83,
	"./contactMail.png": 84,
	"./coursera_logo.png": 85,
	"./data_science.svg": 86,
	"./deeplearning_ai_logo.png": 87,
	"./delhivery_logo.png": 88,
	"./developerActivity.svg": 89,
	"./dsc_logo.png": 90,
	"./education.svg": 91,
	"./experience.svg": 92,
	"./feelingProud.svg": 93,
	"./freecopy_logo.png": 94,
	"./fullstack.svg": 95,
	"./gcp_logo.png": 96,
	"./github_logo.png": 97,
	"./googleAssistant.jpg": 98,
	"./googleAssistant.svg": 99,
	"./google_logo.png": 100,
	"./ibm_logo.png": 101,
	"./iiitk_logo.png": 102,
	"./intel_logo.jpg": 103,
	"./iu_logo.png": 104,
	"./jsFramework.svg": 105,
	"./legato_logo.png": 106,
	"./manOnTable.svg": 107,
	"./microsoft_logo.png": 108,
	"./mozilla_logo.png": 109,
	"./muffito_logo.png": 110,
	"./nextuLogo.jpg": 111,
	"./nptel_logo.png": 112,
	"./portfolio.gif": 113,
	"./programmer.svg": 114,
	"./projects_image.svg": 115,
	"./pwa.png": 116,
	"./saayaHealthLogo.png": 117,
	"./stanford_logo.png": 118,
	"./talksCardBack.svg": 119,
	"./talksCardBackAlt.svg": 120,
	"./tiktok_logo.png": 121,
	"./ui_ux_design.svg": 122
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 77;